import { useQuery } from "@tanstack/react-query";
import { IAdminOfferingGetUsersResponse, getOfferingUsers } from "../clients/admin-client";

export const useOfferingUsers = (offeringId: string) => {
    return useQuery<IAdminOfferingGetUsersResponse>(
      [`offering-users-${offeringId}`],
      () => getOfferingUsers(offeringId)
    );
  };
  